module.exports = __webpack_public_path__ + "img/excavator_h.e77aaa5b.png";